// UserApiService.js
import BaseApiService from './BaseApiService';

class UserApiService extends BaseApiService {
  /**
   * Get user information
   * @returns {Promise} Promise that resolves with user information
   */
  getUserInfo = async () => {
    try {
      const response = await this.getAxiosInstance().get('/auth/me');
      return response.data;
    } catch (error) {
      console.error('Error getting user info:', error);
      throw error;
    }
  };

  /**
   * Get all users (admin only)
   * @returns {Promise} Promise that resolves with users
   */
  getUsers = async () => {
    try {
      const response = await this.getAxiosInstance().get('/users');
      return response.data;
    } catch (error) {
      console.error('Error getting users:', error);
      throw error;
    }
  };

  /**
   * Get user roles (admin only)
   * @param {String} userId User ID
   * @returns {Promise} Promise that resolves with user roles
   */
  getUserRoles = async (userId) => {
    try {
      const response = await this.getAxiosInstance().get(`/users/${userId}/roles`);
      return response.data;
    } catch (error) {
      console.error(`Error getting roles for user ${userId}:`, error);
      throw error;
    }
  };

  /**
   * Get available roles for user (admin only)
   * @param {String} userId User ID
   * @returns {Promise} Promise that resolves with available roles
   */
  getAvailableRoles = async (userId) => {
    try {
      const response = await this.getAxiosInstance().get(`/users/${userId}/available-roles`);
      return response.data;
    } catch (error) {
      console.error(`Error getting available roles for user ${userId}:`, error);
      throw error;
    }
  };

  /**
   * Assign roles to user (admin only)
   * @param {String} userId User ID
   * @param {Array} roles Roles to assign
   * @returns {Promise} Promise that resolves when roles are assigned
   */
  assignRoles = async (userId, roles) => {
    try {
      const response = await this.getAxiosInstance().post(`/users/${userId}/roles`, { roles });
      return response.data;
    } catch (error) {
      console.error(`Error assigning roles to user ${userId}:`, error);
      throw error;
    }
  };

  /**
   * Remove roles from user (admin only)
   * @param {String} userId User ID
   * @param {Array} roles Roles to remove
   * @returns {Promise} Promise that resolves when roles are removed
   */
  removeRoles = async (userId, roles) => {
    try {
      const response = await this.getAxiosInstance().delete(`/users/${userId}/roles`, { data: { roles } });
      return response.data;
    } catch (error) {
      console.error(`Error removing roles from user ${userId}:`, error);
      throw error;
    }
  };
}

export default new UserApiService();